class helpers {

    // Элемент находится в экране или выше (например, когда скролит пользователь)
    // bottom -- указывает на срабатывание триггера в том числе, когда экран ниже элемента, а не только, когда элемент виден
    static elementIsShow = (element, bottom = false) => {
        return new Promise((resolve, reject) => {
            const elementTop = $(element).offset().top;
            const elementBottom = elementTop + $(element).outerHeight();

            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            if (!bottom) {
                if (elementBottom > viewportBottom && elementTop < viewportBottom) {
                    resolve();
                }
            } else {
                if (elementTop < viewportBottom) {
                    resolve();
                }
            }
        });
    }

    // Регионы окна (для всплывающих окон). 2 — потому что в основном у нас мобильные устройства
    static windowRegionsFilling = () => {
        return {
            top: 'window_regions_filling__top',
            bottom: 'window_regions_filling__bottom',
        }
    }

    static shuffle = (array) => {
        if (! Array.isArray(array)) {
            throw new Error('shuffle expect an array as parameter.');
        }

        const shuffledArray = array.slice();

        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }

        return shuffledArray;
    }
}

export default helpers;